export enum LogMode {
    Text = "Text",
    TextAndHtml = "Text And HTML",
}
